/** Grid ↔ world mapping shared by the scene, the labels and the placement ghost (20-base.md R13). */
export const CELL = 1;

/** World X/Z of the centre of a footprint whose top-left cell is (x, y) on a `size`-cell grid centred at the origin. */
export function cellToWorld(x: number, y: number, w: number, h: number, size: number): { wx: number; wz: number } {
  return { wx: (x - size / 2 + w / 2) * CELL, wz: (y - size / 2 + h / 2) * CELL };
}

/** Top-left cell of a footprint whose centre is at world (wx, wz); clamps to the grid. */
export function worldToCell(wx: number, wz: number, w: number, h: number, size: number): { x: number; y: number } {
  const x = Math.round(wx / CELL + size / 2 - w / 2);
  const y = Math.round(wz / CELL + size / 2 - h / 2);
  return { x: Math.max(0, Math.min(size - w, x)), y: Math.max(0, Math.min(size - h, y)) };
}

/** Rotates a footprint (90° steps swap width and height). */
export function rotated(w: number, h: number, rot: number): { w: number; h: number } {
  return rot % 180 === 0 ? { w, h } : { w: h, h: w };
}
